import { render, staticRenderFns } from "./NftItem.vue?vue&type=template&id=cd5ce128&"
import script from "./NftItem.vue?vue&type=script&lang=ts&"
export * from "./NftItem.vue?vue&type=script&lang=ts&"
import style0 from "./NftItem.vue?vue&type=style&index=0&id=cd5ce128&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports